<div class="">
    <form [formGroup]="form">
        <div class="flex items-center gap-4" [ngClass]="{ 'mb-6': isValid }">
            <label for="nombre" class="font-semibold w-48">Nombre de la empresa*</label>
            <input type="text" pInputText id="nombre" formControlName="nombre" placeholder="Ingrese el nombre" class="w-full" [ngClass]="{ 'p-invalid': !isValid }" (update)="checkValid()" />
        </div>
        @if (!isValid) {
            <p class="p-error text-end text-red-600"><small> Este campo es obligatorio. </small></p>
        }

        <div class="flex items-center gap-4" [ngClass]="{ 'mb-6': isValid }">
            <label for="tipo" class="font-semibold w-48">Tipo de Empresa*</label>
            <p-select [showClear]="true" id="tipo" formControlName="tipo_empresa" [options]="tipoEmpresas" optionLabel="nombre" placeholder="Seleccione una opción" [appendTo]="'body'" class="w-full" [ngClass]="{ 'p-invalid': !isValid }" (update)="checkValid()" />
        </div>
        @if (!isValid) {
            <p class="p-error text-end text-red-600"><small> Este campo es obligatorio. </small></p>
        }
    </form>

    <!-- Botones -->
    <div class="flex justify-end gap-3 mt-6">
        <button pButton type="button" label="Cancelar" class="p-button-secondary" (click)="cancelar()"></button>
        <button pButton type="submit" label="Confirmar" (click)="confirmar()"></button>
    </div>
</div>
